export const roadmappingQueryKeys = {
  roadmap: {
    list: () => ['roadmap', 'list'] as const,
    details: (roadmapId: number) => ['roadmap', roadmapId] as const,
    allUsersPermissions: (roadmapId: number) =>
      ['roadmap', roadmapId, 'allUsersPermissions'] as const,
    owner: (roadmapId: number) => ['roadmap', roadmapId, 'owner'] as const,
    userPermissions: (roadmapId: number) => ['roadmap', roadmapId, 'userPermissions'] as const,
  },
  dataset: {
    detail: (roadmapId: number) => ['roadmap', roadmapId, 'dataset'] as const,
  },
  items: {
    partial: () => ['roadmap', 'items'] as const,
    list: ({ filterKey }: { filterKey?: string } = {}) =>
      ['roadmap', 'items', { filterKey }] as const,
  },
  roadmapItems: {
    /** Partial key to invalidate all items for a roadmap */
    partial: (roadmapId: number) => ['roadmap', roadmapId, 'items'] as const,
    detail: (roadmapId: number, filterKey?: string) =>
      ['roadmap', roadmapId, 'items', { filterKey }] as const,
  },
  itemsViewLayout: {
    detail: (roadmapId: number) => ['roadmap', roadmapId, 'items', 'layout'] as const,
  },
  roadmapViewItems: {
    /** Partial key to invalidate all view items for a roadmap */
    partial: (roadmapId: number) => ['roadmap', roadmapId, 'view'] as const,
    detail: (roadmapId: number, viewId: number, visualizationId?: number) =>
      visualizationId === undefined
        ? (['roadmap', roadmapId, 'view', viewId, 'items'] as const)
        : (['roadmap', roadmapId, 'view', viewId, 'items', { visualizationId }] as const),
  },
  visualization: {
    all: (viewId: number) => ['visualization', 'list', viewId] as const,
    detail: (viewId: number, visualizationId: number) =>
      ['visualization', 'detail', viewId, visualizationId] as const,
    byType: (viewId: number, type: string) => ['visualization', 'byType', viewId, type] as const,
  },
  swimlaneLayout: {
    detail: (viewId: number, visualizationId: number) =>
      ['swimlane-layout', viewId, visualizationId] as const,
    headerConfig: (viewId: number, visualizationId: number, headerFieldId: string) =>
      ['swimlane-layout', 'header-config', viewId, visualizationId, headerFieldId] as const,
  },
  tableLayout: {
    detail: (viewId: number, visualizationId: number) =>
      ['table-layout', viewId, visualizationId] as const,
  },
  timelineLayout: {
    detail: (viewId: number, visualizationId: number) =>
      ['timeline-layout', viewId, visualizationId] as const,
    headerConfig: ({
      viewId,
      visualizationId,
      headerFieldId,
      parentFieldId,
      parentHeaderId,
    }: {
      viewId: number;
      visualizationId: number;
      headerFieldId: string;
      parentFieldId?: string | null;
      parentHeaderId?: string | null;
    }) =>
      [
        'timeline-layout',
        'header-config',
        viewId,
        visualizationId,
        headerFieldId,
        parentFieldId,
        parentHeaderId,
      ] as const,
  },
  publishedVisualization: {
    detail: (viewId: number, visualizationId: number) =>
      ['published-visualization', viewId, visualizationId] as const,
  },
};
